class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();
    this.setMiniCartHover();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-label", "View cart");

    // Change from 'click' to 'mouseover'
    // cartLink.addEventListener('click', (event) => {
    //   event.preventDefault();
    //   this.open(cartLink);
    // });
    cartLink.addEventListener("mouseover", (event) => {
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  setMiniCartHover() {
    const cartIconBubble = document.querySelector("#cart-icon-bubble");
    if (!cartIconBubble) return;

    const miniCart = this;
    let timeoutId = null; // This will store the timeout ID

    // Function to open the mini cart
    const openMiniCart = () => {
      clearTimeout(timeoutId); // Clear any existing timeout to prevent it from closing
      this.open(cartIconBubble);
    };

    // Function to close the mini cart with a delay
    const closeMiniCartDelayed = () => {
      clearTimeout(timeoutId); // Clear any existing timeout to prevent multiple triggers
      timeoutId = setTimeout(() => {
        this.close();
      }, 400); // Set a delay of 400ms before closing the mini cart
    };

    // When mouse enters the cart icon or the mini cart, open the mini cart
    cartIconBubble.addEventListener("mouseover", openMiniCart);
    miniCart.addEventListener("mouseover", openMiniCart);

    // When mouse leaves the cart icon or the mini cart, start the delay to close it
    cartIconBubble.addEventListener("mouseout", closeMiniCartDelayed);
    miniCart.addEventListener("mouseout", (event) => {
      // This checks if the mouse has actually left the mini cart or just entered a child element
      if (!miniCart.contains(event.relatedTarget)) {
        closeMiniCartDelayed();
      }
    });
  }

  keepOpen() {
    // Method to keep the mini cart open when the mouse is over it
  }

  open(triggeredBy) {
    // Check if the cart is marked as empty or if the viewport width is below 1000px
    const isCartEmpty = this.classList.contains("ob-cart-empty");
    const isMobileView = window.innerWidth < 1000;
    const isCartPage = window.routes.cart_url;

    if (
      isCartEmpty ||
      isMobileView ||
      window.location.href.includes(isCartPage)
    ) {
      // If either condition is true, remove the 'active' class if it exists and exit the function
      this.classList.remove("active");
      return;
    }

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      // this.classList.add('animate', 'active');
      this.classList.add("active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn =
          this.classList.contains("is-empty") ?
            this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    // document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    // document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement =
        section.selector ?
          document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
